import React from 'react'

function Footer() {
    return (
        <footer className="main-footer">
            <strong>Copyright © {new Date().getFullYear()} <a href="#">Naariyal Paniwala</a>. </strong>
            All rights reserved.
            <div className="float-right d-none d-sm-inline-block">
                {/* <b>Version</b> 3.2.0 */}
            </div>
        </footer>
    )
}

export default Footer